export const getTextSizeClasses = (textElement) => {
    switch (textElement) {
        case 'h1':
            return 'text-[30px] font-bold leading-[36px]';
        case 'h2':
            return 'text-[24px] font-bold leading-[28px]';
        case 'h3':
            return 'text-[18px] font-bold leading-[28px]';
        case 'span':
        default:
            return 'text-[14px] leading-[24px]';
    }
};
export const utcToInputFormat = (utcValue, inputType) => {
    if (utcValue === undefined || utcValue === null || utcValue === '') {
        return '';
    }
    const date = new Date(utcValue);
    if (isNaN(date.getTime())) {
        return '';
    }
    switch (inputType) {
        case 'time':
            return date.toTimeString().slice(0, 5);
        case 'date':
            return date.toISOString().split('T')[0];
        case 'datetime-local':
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        default:
            return String(utcValue);
    }
};
export const inputFormatToUtc = (inputValue, inputType) => {
    if (!inputValue || inputValue.trim() === '') {
        return '';
    }
    let date;
    switch (inputType) {
        case 'time':
            const today = new Date();
            const [hours, minutes] = inputValue.split(':');
            date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(hours, 10), parseInt(minutes, 10));
            break;
        case 'date':
            date = new Date(inputValue + 'T00:00:00');
            break;
        case 'datetime-local':
            date = new Date(inputValue);
            break;
        default:
            date = new Date(inputValue);
    }
    if (isNaN(date.getTime())) {
        return '';
    }
    return date.toISOString();
};
export const getCurrencySymbol = (currencyCode, locale = 'en-US') => {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const parts = formatter.formatToParts(1);
    const symbolPart = parts.find(part => part.type === 'currency');
    return symbolPart ? symbolPart.value : '';
};
